"use client";

import React, { useEffect, useState } from "react";
import DynamicIsland from "./dynamic-island";

type AlertType = "subscribe" | "follow" | "subgift" | "cheer" | null;

interface AlertData {
  type: AlertType;
  username: string;
  recipient?: string;
  amount?: number;
  tier?: string;
  months?: number;
}

export default function AlertBox() {
  const [currentAlert, setCurrentAlert] = useState<AlertData | null>(null);
  const [alertQueue, setAlertQueue] = useState<AlertData[]>([]);
  const [isVisible, setIsVisible] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (alertQueue.length > 0 && !isProcessing) {
      processNextAlert();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertQueue, isProcessing]);

  useEffect(() => {
    let socket: WebSocket;
    let keepAliveInterval: NodeJS.Timeout;
    let reconnectTimeout: NodeJS.Timeout;

    const connectWebSocket = () => {
      socket = new WebSocket(
        "wss://realtime.streamelements.com/socket.io/?cluster=main&EIO=3&transport=websocket",
      );

      socket.onopen = () => {
        console.log("WebSocket connected");
        socket.send(
          `42["authenticate", {"method": "apikey", "token": "6p23dBMB47StMxwQVgzfc72jqfcYhxtkQU2ssaUMaUN4Dqfl"}]`,
        );
        keepAliveInterval = setInterval(() => {
          socket.send("2");
        }, 25000);
      };

      socket.onmessage = (event) => {
        const data = event.data;

        // Parse the incoming message
        if (data.startsWith("42")) {
          const parsedData = JSON.parse(data.substring(2));
          const [eventType, payload] = parsedData;

          if (eventType === "event") {
            const { type, data: eventData } = payload;
            if (type === "communityGiftPurchase" && eventData?.amount >= 5) {
              playSound();
            }

            if (type === "follow") {
              addToQueue({ type: "follow", username: eventData.username });
            } else if (type === "subscriber") {
              const tier = eventData.tier ?? "Tier 1";
              addToQueue({
                type: "subscribe",
                username: eventData.username,
                tier,
              });
            } else if (type === "cheer") {
              addToQueue({
                type: "cheer",
                username: eventData.username,
                amount: eventData.amount,
              });
            } else if (type === "gift") {
              console.log("Subgift event received:", eventData);
              addToQueue({
                type: "subgift",
                username: eventData.sender,
                recipient: eventData.recipient,
                tier: eventData.tier,
              });
            }
          }
        }
      };

      socket.onclose = () => {
        console.log("WebSocket disconnected");
        clearInterval(keepAliveInterval);
        reconnectTimeout = setTimeout(() => {
          console.log("Attempting to reconnect...");
          connectWebSocket();
        }, 5000);
      };

      socket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    };

    connectWebSocket();

    return () => {
      if (socket) socket.close();
      clearInterval(keepAliveInterval);
      clearTimeout(reconnectTimeout);
    };
  }, []);

  const addToQueue = (alert: AlertData) => {
    setAlertQueue((prev) => [...prev, alert]);
  };

  function playSound() {
    const audio = new Audio("/szakadekok.mp3");
    audio.volume = 0.3;
    audio.play().catch((err) => {
      console.error("Sound issue:", err);
    });
  }

  const processNextAlert = () => {
    setIsProcessing(true);
    const nextAlert = alertQueue[0];
    setAlertQueue((prev) => prev.slice(1));
    setCurrentAlert(nextAlert);
    setIsVisible(true);

    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentAlert(null);
        setTimeout(() => {
          setIsProcessing(false);
        }, 1000);
      }, 500);
    }, 4000);
  };

  return (
    <div className="fixed top-[45px] left-[600px] z-50 pointer-events-none">
      {currentAlert && (
        <DynamicIsland alert={currentAlert} isVisible={isVisible} />
      )}
    </div>
  );
}
